import {genderList} from '@/plugins/consts'

/**
 * Фильтр-функция для телефона. Выводит номер в формате +7-XXX-XXX-XX-XX
 */
export function phoneFilter(val) {
  if (!val) {
    return '—'
  }
  let phone = val.replace(/\D/g, '')
  if (phone.length !== 10) {
    return phone
  }
  return `+7 (${phone.substring(0, 3)}) ${phone.substring(3, 6)} ${phone.substring(6, 10)}`
}

/**
 * Вывод пол пациента по значению Enum
 */
export function genderFilter(val){
  let gender = genderList.find(it => it.value === val)
  if (gender === undefined) {
    return 'Не определён'
  }
  return gender.text
}